if (!customElements.get('nova-marathon-collection')) {
  customElements.define('nova-marathon-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const prices = [...this.querySelectorAll('[data-nmc-price]')].filter(price => !price.textContent.trim());
      if (prices.some(price => !price.textContent.trim()) && this.dataset.productUrl) {
        fetch(`${this.dataset.productUrl}${this.dataset.productUrl.includes('?')?'&':'?'}section_id=nova-marathon-price`, {headers: {Accept: 'text/html'}})
          .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.text(); })
          .then(html => {
            const priceText = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nmc-server-price]')?.textContent.trim();
            if (!priceText) throw new Error('Price unavailable');
            prices.forEach(price => { price.textContent = priceText; const container = price.closest('[data-nmc-price-wrap]'); if (container) container.hidden = false; });
          })
          .catch(() => { prices.forEach(price => { const container = price.closest('[data-nmc-price-wrap]'); if (container) container.hidden = true; }); });
      }
      const products = this.querySelector('[data-nmc-products]');
      const sort = this.querySelector('[data-nmc-sort]');
      const country = this.querySelector('[data-nmc-country]');
      const productCards = [...this.querySelectorAll('[data-nmc-product]')];
      const sortProducts = () => {
        const value = sort?.value || 'featured';
        const sorted = [...productCards].sort((a,b) => value.startsWith('title') ? a.dataset.title.localeCompare(b.dataset.title) * (value.endsWith('descending')?-1:1) : value.startsWith('price') ? (Number(a.dataset.price)-Number(b.dataset.price)) * (value.endsWith('descending')?-1:1) : Number(a.dataset.position)-Number(b.dataset.position));
        sorted.forEach(card => { card.hidden = !!(country?.value && card.dataset.country !== country.value); products?.append(card); });
      };
      sort?.addEventListener('change',sortProducts);
      country?.addEventListener('change',sortProducts);
      const filters = this.querySelector('[data-nmc-filters]');
      const city = this.querySelector('[data-nmc-city]');
      const distance = this.querySelector('[data-nmc-distance]');
      const cards = [...this.querySelectorAll('[data-nmc-route]')];
      const search = this.querySelector('[data-nmc-search]');
      const count = this.querySelector('[data-nmc-count]');
      if (!filters || !city || !distance || !count) return;
      const update = () => {
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !!((city.value && city.value !== card.dataset.city) || (distance.value && distance.value !== card.dataset.distance) || (search?.value && !card.innerText.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').includes(search.value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''))));
          if (!card.hidden) visible++;
        });
        count.textContent = String(visible);
      };
      filters.addEventListener('change', update);
      search?.addEventListener('input', update);
      filters.hidden = false;
      update();
    }
  });
}

